export function getUnique(prefix = '', regex = /^(\d+)$/, list = []) {
  let maxNumber = 0
  for (const item of list) {
    const match = item.match(regex)

    if (!match) {
      continue
    }

    const number = Number(match[1])

    if (number > maxNumber) {
      maxNumber = number
    }
  }

  return `${prefix}${maxNumber + 1}`
}
